// extracted by mini-css-extract-plugin
module.exports = {"root":"document-folder_root__mMkTr","titleBlock":"document-folder_titleBlock__ep7ot","button":"document-folder_button__T8WrT","icon":"document-folder_icon__znwBn"};